import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import CheckBox from "~/componentes/CustomForm/Check/styles/CheckBox";

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import Acoordion from '~/componentes/Acoordion';
import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';

function EditContent({ mountedData, analistas }) {
  const [meses, setMeses] = useState([]);
  const [anos, setAnos] = useState([]);
  const [ordensServicos, setOrdensServicos] = useState([]);

  useEffect(() => {
    let listaMeses = [
      { id: 1, sigla: "JAN", titulo: "Janeiro" },
      { id: 2, sigla: "FEV", titulo: "Fevereiro" },
      { id: 3, sigla: "MAR", titulo: "Março" },
      { id: 4, sigla: "ABR", titulo: "Abril" },
      { id: 5, sigla: "MAI", titulo: "Maio" },
      { id: 6, sigla: "JUN", titulo: "Junho" },
      { id: 7, sigla: "JUL", titulo: "Julho" },
      { id: 8, sigla: "AGO", titulo: "Agosto" },
      { id: 9, sigla: "SET", titulo: "Setembro" },
      { id: 10, sigla: "OUT", titulo: "Outubro" },
      { id: 11, sigla: "NOV", titulo: "Novembro" },
      { id: 12, sigla: "DEZ", titulo: "Dezembro" },
    ];
    setMeses(listaMeses);

    setAnos([
      { id: new Date().getFullYear() - 2 },
      { id: new Date().getFullYear() - 1 },
      { id: new Date().getFullYear() },
    ]);

    let lista = [];
    for (let item of mountedData?.ordensServicos) {
      lista.push({ check: true, ...item });
    }
    setOrdensServicos(lista);
  }, [mountedData]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    closeReload && closeReload();
    return {};
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="row">
            <Label title="Data Emissão*" className="col s12 m4 l2">
              <Input
                type="date"
                name="dataEmissao"
                required="true"
                readOnly="true"
                defaultValue={mountedData?.dataEmissao}
              />
            </Label>
            <Label title="Título *" className="col s12 m8 l4">
              <Input
                name="titulo"
                required="true"
                disabled="true"
                defaultValue={mountedData?.titulo}
              />
            </Label>
            <Label title="Analista *" className="col s12 m12 l2">
              <Select
                required="true"
                isString
                list={{
                  list: analistas,
                  value: 'id',
                  label: 'nome',
                }}
                name="idAnalista"
                disabled="true"
                defaultValue={mountedData?.idAnalista}
              />
            </Label>
            <Label title="Mês *" className="col s12 m12 l2">
              <Select
                required="true"
                isString
                list={{
                  list: meses,
                  value: "id",
                  label: "titulo",
                }}
                name="mesFechamento"
                disabled="true"
                defaultValue={mountedData?.mesFechamento}
                firstOption
              />
            </Label>
            <Label title="Ano *" className="col s12 m12 l2">
              <Select
                required="true"
                isString
                list={{
                  list: anos,
                  value: "id",
                  label: "titulo",
                }}
                name="anoFechamento"
                disabled="true"
                defaultValue={mountedData?.anoFechamento}
                firstOption
              />
            </Label>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <div className="header-os">
                <div className="header-left">
                  <p className="title_p">Ordens de Serviços *</p>
                </div>
                <div className="header-right">
                  <div className="check-all">
                    <p className="title_p">Marcar Todos</p>
                    <div className="card-check checked" >
                      <span />
                    </div>
                  </div>
                </div>
              </div>
              <div className="content-atividade">
                <div className="atv-content">
                  <div className="atv-content-top">
                    <div className="col col0-5 center">
                      <p className="ativo">#</p>
                    </div>
                    <div className="col col3">
                      <p>Título</p>
                    </div>
                    <div className="col col2">
                      <p>Analista</p>
                    </div>
                    <div className="col col1 center">
                      <p>Emissão</p>
                    </div>
                    <div className="col col1 center">
                      <p>Apontada</p>
                    </div>
                    <div className="col col1 center">
                      <p>Desconto</p>
                    </div>
                    <div className="col col1 center">
                      <p>Translado</p>
                    </div>
                    <div className="col col1 center">
                      <p>Total</p>
                    </div>
                    <div className="col col2">
                      <p>Coordenador</p>
                    </div>
                    <div className="col col1">
                      <p>Atv. Ent.</p>
                    </div>
                    <div className="col col0-5 center"> - </div>
                  </div>
                </div>
                {ordensServicos?.map((item, index) => (
                  <div className="atv-content">
                    <div className="atv-content-top">
                      <div className="col col0-5">
                        <p className="ativo">#{item?.id}</p>
                      </div>
                      <div className="col col3">
                        <p>{item?.titulo}</p>
                      </div>
                      <div className="col col2">
                        <p>{item?.analista?.nome}</p>
                      </div>
                      <div className="col col1 center">
                        <p>{((new Date(item?.dataEmissao).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaApontada}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaDesconto}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaTranslado}h</p>
                      </div>
                      <div className="col col1 center">
                        <p>{item?.horaTotal}h</p>
                      </div>
                      <div className="col col2">
                        <p>{item?.coordenador?.nome}</p>
                      </div>
                      <div className="col col1">
                        <p>{((new Date(item?.atividades[0]?.projetoAtividade?.previsaoEntrega).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
                      </div>
                      <div className="col col0-5">
                        <div className="card-check checked">
                          <span />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Materialize>
    </Container >
  );
}

export default EditContent;
